/* eslint-disable react/prop-types */
import React from 'react';
import { AppWithGlobalState } from 'components/App';
import Loading from 'components/Loading';
import { formatWrappedComponentDisplayName } from 'util/hoc';
import { FAQ, POST } from 'constants/pageTypes';

export default (WrappedComponent, { showLoading = true } = {}) => {
  function withFlowLayout(props) {
    const {
      pageBundles,
      pageType,
      contentBundles,
      contentStats,
      onLoadMore,
      isLoadingMore,
      hasMore,
      ...rest
    } = props;
    // CLEANUP: convert to op, like showLoading
    const setNoSkim = !(pageType === POST || pageType === FAQ);
    return (
      <AppWithGlobalState
        pageBundles={pageBundles}
        pageType={pageType}
        setNoSkim={setNoSkim}
        contentStats={contentStats}
      >
        {contentBundles || showLoading === false ? (
          <WrappedComponent
            contentBundles={contentBundles}
            onLoadMore={onLoadMore}
            isLoadingMore={isLoadingMore}
            hasMore={hasMore}
            {...rest}
          />
        ) : (
          <Loading height="300px" />
        )}
      </AppWithGlobalState>
    );
  }

  // prettier-ignore
  withFlowLayout.displayName = formatWrappedComponentDisplayName('withFlowLayout', WrappedComponent);

  return withFlowLayout;
};
